<template>
  <div>
    <b-modal @hide="hideModal()" :visible="modal.show" @show="onModalShow">
      <template v-slot:modal-header>
        <h5 class="modal-title">
          {{ $t('Resume')}} {{sale.title | masterLanguage}}
        </h5>
        <button type="button" @click="hideModal()" aria-label="Close" class="close">×
        </button>
      </template>
      <template v-slot:modal-footer>
        <cancel-button :disabled="loading" @click="hideModal()"/>
        <submit-button variant="success" :disabled="loading || !resume_date || !resume_time" :show-loader="loading"
                       @click="onSubmitClick"/>
      </template>
      <div class="mt-2">
        <b-alert variant="info" show="true">
          {{$t('Please enter new end date for the first most immediate lot. Time extensions for next lots will follow based on that new end date.')}}
        </b-alert>
        <b-form-group class="mb-0 mt-2">
          <b-input-group>
            <b-form-input v-model="resume_date" type="date" :min="getCurrentDate" :dateFormatOptions="{ year: 'numeric', month: 'long', day: 'numeric' }"/>
            <b-form-input v-model="resume_time" type="time" :label="false" :hour12="false"/>
          </b-input-group>

        </b-form-group>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import CancelButton from "../../core/components/common/CancelButton";
  import SubmitButton from "../../core/components/common/SubmitButton";
  import {createNamespacedHelpers} from "vuex";
  import {SYSTEM_DATE_FORMAT, SYSTEM_TIME_FORMAT} from "@/core/services/formatter.service";
  import moment from "moment";

  const {mapState, mapActions} = createNamespacedHelpers('sales');

  export default {
    name: "SaleResumeModal",
    components: {SubmitButton, CancelButton},
    computed: {
      ...mapState({
        modal: state => state.saleResumeModal,
        sale: state => state.view.currentSale
      }),
      getCurrentDate() {
        return this.$options.filters.toDate(new Date(), SYSTEM_DATE_FORMAT)
      },
    },
    data() {
      return {
        loading: false,
        resume_date: null,
        resume_time: null,
      }
    },
    methods: {
      ...mapActions(['hideSaleResumeModal', 'pauseResumeAction']),
      hideModal() {
        this.resume_date = null;
        this.resume_time = null;
        this.loading = false;
        this.hideSaleResumeModal();
      },
      onModalShow() {
      },
      async onSubmitClick(_, extraHandler) {
        this.loading = true;
        let response = await this.pauseResumeAction({
          uuid: this.sale.uuid,
          is_paused: false,
          pause_message: {},
          resume_date: moment(`${this.resume_date} ${this.resume_time}`).utc().format(`${SYSTEM_DATE_FORMAT} ${SYSTEM_TIME_FORMAT}`)
        });
        this.loading = true;
        if (response.success) {
          this.$toast('success', this.$i18n.t('Auction successfully resumed.'));
          this.hideModal();
        } else {
          if (response.body && response.body.non_field_errors) {
            if (typeof response.body.non_field_errors === 'object' && response.body.non_field_errors.length > 1) {
              const listItemsArr = [];
              response.body.non_field_errors.forEach(err => listItemsArr.push(this.$createElement('li', {}, err)))
              this.$errorDialog(this.$createElement('ul', {class: "mb-0"}, listItemsArr), this.$i18n.t('Validation Error'));
            } else {
              this.$errorDialog(response.body.non_field_errors[0]);
            }
          }
          this.hideModal();
        }
      },
    }
  }
</script>

<style scoped>

</style>
